import { MapPin, Phone } from "lucide-react";

const SUBURBS = [
  "Currambine",
  "Joondalup",
  "Kinross",
  "Iluka",
  "Burns Beach",
  "Connolly",
  "Edgewater",
  "Ocean Reef",
  "Mullaloo",
  "Hillarys",
  "Sorrento",
  "Duncraig",
  "Kingsley",
  "Padbury",
  "Craigie",
  "Heathridge",
  "Beldon",
  "Woodvale",
  "Clarkson",
  "Mindarie",
  "Quinns Rocks",
  "Butler",
];

export default function ServiceArea() {
  return (
    <section id="area" data-testid="service-area-section" className="relative py-20 sm:py-28 overflow-hidden bg-slate-900">
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900" />
        <div
          className="absolute inset-0 opacity-30"
          style={{
            backgroundImage:
              "radial-gradient(circle at 20% 20%, rgba(37, 99, 235, 0.35) 0%, transparent 45%), radial-gradient(circle at 80% 70%, rgba(217, 119, 6, 0.25) 0%, transparent 50%)",
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 text-white">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/20 px-4 py-2 text-sm">
            <MapPin className="w-4 h-4 text-[#D97706]" />
            Service area
          </div>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Proudly servicing Perth's north-western suburbs.
          </h2>
          <p className="mt-5 text-lg text-white/85 leading-relaxed">
            Based in Currambine, Western Australia — covering the whole
            north-western Perth region, usually with same-week appointments and
            often same-day for urgent issues.
          </p>
        </div>

        <div className="mt-10 flex flex-wrap gap-3" data-testid="suburbs-list">
          {SUBURBS.map((s) => (
            <span
              key={s}
              className="px-4 py-2 rounded-full bg-white/10 border border-white/20 text-sm font-medium"
              data-testid={`suburb-${s.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {s}
            </span>
          ))}
        </div>

        <div className="mt-12 flex flex-col sm:flex-row gap-3">
          <a
            href="tel:0409049094"
            data-testid="area-call-button"
            className="inline-flex items-center justify-center gap-2 h-14 px-7 rounded-xl bg-white text-slate-900 font-semibold text-lg hover:bg-[#FDFBF7] transition-all"
          >
            <Phone className="w-5 h-5" strokeWidth={2.25} />
            Call 0409 049 094
          </a>
          <a
            href="#enquiry"
            data-testid="area-enquiry-button"
            className="inline-flex items-center justify-center gap-2 h-14 px-7 rounded-xl border-2 border-white/60 text-white font-semibold text-lg hover:bg-white/10 transition-all"
          >
            Not in the list? Ask anyway
          </a>
        </div>
      </div>
    </section>
  );
}
